import util from './_utils';

const container = d3.select('.graphic__chart'),
	rightPanel = d3.select('.graphic__right'),
	svg = container.select('.svg__track'),
	g = svg.select('g'),
	button = d3.selectAll('.button');

let x, y, yMax, margin, w, h;

let data, vizParameters, isMobile, drawn = false,
	fullyDrawn = false;

let track, starts, ends;

const trackConsistent = true;

let step = -2,
	startW = 18,
	duration = {
		fast: 250,
		medium: 500,
		slow: 1000,
		reallySlow: 5000
	}

function init(fromMenu = false) {
	data = isMobile ? [0, 2.5, 5, 7.5, 10] : [0, 2.5, 5, 7.5, 10, 12.5];

	setup(false, fromMenu);
}

function next(index) {
	step = index;

	//buttonDelay();
	if (index == -1) draw();
	if (index > -1) update();
}

function setup(resize = false, fromMenu = false) {
	isMobile = util.isMobile();
	vizParameters = getVizParameters();

	data = isMobile ? [0, 2.5, 5, 7.5, 10] : [0, 2.5, 5, 7.5, 10, 12.5];

	margin = {
		// top: vizParameters.headerH,
		top: 0,
		right: isMobile ? 30 : 0,
		bottom: 0,
		left: isMobile ? 30 : 45
	}
	w = vizParameters.outerW - margin.right - margin.left;
	h = vizParameters.outerH - margin.top - margin.bottom;

	x = d3.scaleLinear().domain([0, 10]).range([0, w]);
	y = d3.scaleLinear().domain([0, 100]).range([0, h]);

	yMax = isMobile ? 200 : 100;

	g.attr('transform', `translate(${margin.left}, ${margin.top})`);

	if (!resize) {
		draw(fromMenu)
	} else {
		resizeTrack()
	};
}

function draw(fromMenu = false) {
	drawn = true;

	starts = g.selectAll('.track-start-line').data(data);
	ends = g.selectAll('.track-end-line').data(data);
	track = g.selectAll('.track-line').data(data);

	starts.enter()
		.append('line')
		.attr('class', 'track-start-line')
		.attr('x1', d => x(d) - startW / 2).attr('x2', d => x(d) - startW / 2)
		.attr('y1', y(isMobile ? 150 : 75)).attr('y2', y(isMobile ? 150 : 75))
		.transition().duration(duration.slow)
		.delay((d, i) => i * 75)
		.attr('x2', d => x(d) + startW / 2);

	ends.enter()
		.append('line')
		.attr('class', 'track-end-line')
		.attr('x1', d => x(d) - startW / 2).attr('x2', d => x(d) + startW / 2)
		.attr('y1', y(isMobile ? 210 : 105)).attr('y2', y(isMobile ? 210 : 105));

	track.enter()
		.append('line')
		.attr('class', 'track-line')
		.attr('x1', d => x(d)).attr('x2', d => x(d))
		.attr('y1', y(isMobile ? 150 : 75)).attr('y2', y(isMobile ? 150 : 75))
		.transition().duration(duration.slow)
		.delay((d, i) => (duration.medium / 2) + util.randomNumber(50, 200))
		.attr('y2', y(isMobile ? 210 : 105));

	// if (fromMenu) update();
}

function update() {
	fullyDrawn = true;
	starts = g.selectAll('.track-start-line');
	track = g.selectAll('.track-line');

	starts.transition().duration(duration.medium)
		.attr('y1', y(-5)).attr('y2', y(-5));

	track.transition().duration(duration.medium)
		.attr('y1', y(0)).attr('y2', step == 0 ? y(isMobile ? 210 : 105) : trackConsistent ? y(isMobile ? 210 : 105) : y(util.randomNumber(5, 25)))
		.transition().duration(duration.medium)
		.delay(util.randomNumber(25, 150))
		.attr('y2', y(isMobile ? 210 : 105));
}

function end() {
	if (drawn) {
		starts = g.selectAll('.track-start-line').data([]);
		ends = g.selectAll('.track-end-line').data([]);
		track = g.selectAll('.track-line').data([]);

		starts.exit()
			.transition().duration(duration.medium)
			.delay((d, i) => (duration.medium / 2) + i * 50)
			.attr('y1', fullyDrawn ? y(isMobile ? 10 : 25) : y(isMobile ? 150 : 75))
			.attr('y2', fullyDrawn ? y(isMobile ? 10 : 25) : y(isMobile ? 150 : 75))
			.transition().duration(duration.medium)
			.delay((d, i) => (duration.medium / 2) + i * 50)
			.attr('y1', fullyDrawn ? y(0) : y(isMobile ? 210 : 105))
			.attr('y2', fullyDrawn ? y(0) : y(isMobile ? 210 : 105))
			.remove();

		ends.exit()
			.transition().duration(duration.medium)
			.delay((d, i) => (duration.medium / 2) + i * 50)
			.attr('y1', fullyDrawn ? y(0) : y(isMobile ? 210 : 105)).attr('y2', fullyDrawn ? y(0) : y(isMobile ? 210 : 105))
			.remove();

		track.exit()
			.transition().duration(duration.medium)
			.delay((d, i) => (duration.medium / 2) + i * 50)
			.attr('y1', fullyDrawn ? y(0) : y(isMobile ? 150 : 75))
			.attr('y2', fullyDrawn ? y(isMobile ? 10 : 25) : y(isMobile ? 150 : 75))
			.transition().duration(duration.medium)
			.delay((d, i) => (duration.medium / 2) + i * 50)
			.attr('y1', fullyDrawn ? y(0) : y(isMobile ? 210 : 105))
			.attr('y2', fullyDrawn ? y(0) : y(isMobile ? 210 : 105))
			.remove();
		drawn = false;
		fullyDrawn = true;
	}
}

function resizeTrack() {
	if (drawn) {
		starts = g.selectAll('.track-start-line').data(data);
		ends = g.selectAll('.track-end-line').data(data);
		track = g.selectAll('.track-line').data(data);

		starts.transition().duration(0)
			.attr('x1', d => x(d) - startW / 2).attr('x2', d => x(d) + startW / 2)
			.attr('y1', step == -2 || step == -1 ? y(isMobile ? 150 : 75) : y(-5)).attr('y2', step == -2 || step == -1 ? y(isMobile ? 150 : 75) : y(-5))

		ends.transition().duration(0)
			.attr('x1', d => x(d) - startW / 2).attr('x2', d => x(d) + startW / 2)
			.attr('y1', y(isMobile ? 210 : 105)).attr('y2', y(isMobile ? 210 : 105));

		track.transition().duration(0)
			.attr('x1', d => x(d)).attr('x2', d => x(d))
			.attr('y1', step == -2 || step == -1 ? y(isMobile ? 150 : 75) : y(0)).attr('y2', y(isMobile ? 210 : 105));
		// .attr('y1', y(0)).attr('y2', y(isMobile ? 210 : 105));
	}
}

function buttonDelay() {
	button.style('pointer-events', 'none').transition().delay(1000).style('pointer-events', 'all');
}

function getVizParameters() {
	const rightW = rightPanel.node().offsetWidth,
		rightH = rightPanel.node().offsetHeight,
		headerH = isMobile ? 56 : 75,
		outerW = container.node().offsetWidth - (isMobile ? 0 : rightW),
		outerH = container.node().offsetHeight - (isMobile ? rightH : 0);

	const x = outerW / 2,
		y = outerH / 2;

	return {
		rightW: rightW,
		rightH: rightH,
		headerH: headerH,
		outerW: outerW,
		outerH: outerH,
		x: x,
		y: y
	};
}

export default {
	init,
	setup,
	next,
	end,
	resizeTrack,
	draw
}